import React, { useMemo } from 'react';

import MenuItemDropdown, { MenuItemLink } from './MenuItem';
import MenuList from './MenuList';

import config from 'appconfig';

const topMenuItemsSC = [
  {
    Component: MenuItemDropdown,
    menuKey: 'products',
    text: 'navigation.header.products',
  },
  {
    Component: MenuItemDropdown,
    menuKey: 'teams',
    text: 'navigation.header.teams',
  },
  {
    Component: MenuItemDropdown,
    menuKey: 'support',
    text: 'navigation.header.support',
  },
  {
    Component: MenuItemLink,
    href: `${config.wacUrl}/try`,
    text: 'navigation.header.try',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}`,
    text: 'navigation.header.buy',
  },
];

const topMenuItemsMAC = [
  {
    Component: MenuItemLink,
    href: `${config.root}/my`,
    text: 'navigation.header.licenses',
  },
  {
    Component: MenuItemLink,
    href: `${config.wacUrl}/download`,
    text: 'navigation.header.downloads',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}/my/orders`,
    text: 'navigation.header.orders',
  },
  {
    Component: MenuItemLink,
    href: `${config.root}`,
    text: 'navigation.header.buy',
  },
];

type PropTypes = {
  cartMACFunctionalityMigration: boolean;
  isMACPage: boolean;
};

const TopMenu: React.FC<PropTypes> = React.memo(({ isMACPage, cartMACFunctionalityMigration }) => {
  const topMenuItems = useMemo(
    () => (cartMACFunctionalityMigration && isMACPage ? topMenuItemsMAC : topMenuItemsSC),
    [cartMACFunctionalityMigration, isMACPage],
  );

  return (
    <MenuList isMACPage={isMACPage}>
      {topMenuItems.map((item) => {
        const { Component, ...props } = item;

        return <Component key={props.text} {...props} />;
      })}
    </MenuList>
  );
});

export default TopMenu;
